import React, { useState } from 'react'
import { Dashboard } from './Dashboard'
import { Links } from './Links'
import { Usage } from './Usage'

type TabType = 'dashboard' | 'links' | 'usage'

function App() {
  const [activeTab, setActiveTab] = useState<TabType>('dashboard')

  return (
    <div>
      <h1>Dev Portal</h1>

      <nav style={{ borderBottom: '1px solid #ccc', marginBottom: '20px' }}>
        <button
          onClick={() => setActiveTab('dashboard')}
          style={{
            padding: '10px 20px',
            marginRight: '10px',
            fontWeight: activeTab === 'dashboard' ? 'bold' : 'normal',
            borderBottom: activeTab === 'dashboard' ? '2px solid blue' : 'none',
            cursor: 'pointer',
            background: 'none',
            border: 'none',
          }}
        >
          Dashboard
        </button>
        <button
          onClick={() => setActiveTab('links')}
          style={{
            padding: '10px 20px',
            marginRight: '10px',
            fontWeight: activeTab === 'links' ? 'bold' : 'normal',
            borderBottom: activeTab === 'links' ? '2px solid blue' : 'none',
            cursor: 'pointer',
            background: 'none',
            border: 'none',
          }}
        >
          Links
        </button>
        <button
          onClick={() => setActiveTab('usage')}
          style={{
            padding: '10px 20px',
            fontWeight: activeTab === 'usage' ? 'bold' : 'normal',
            borderBottom: activeTab === 'usage' ? '2px solid blue' : 'none',
            cursor: 'pointer',
            background: 'none',
            border: 'none',
          }}
        >
          Usage Guide
        </button>
      </nav>

      <div>
        {activeTab === 'dashboard' && <Dashboard />}
        {activeTab === 'links' && <Links />}
        {activeTab === 'usage' && <Usage />}
      </div>
    </div>
  )
}

export default App

